import React, { useEffect, useRef, useState } from "react";
import SmartPopup from "../../components/Dailogs/SmartPopup";
import { useLocation } from "react-router-dom";
import {
  AddTaskActivity,
  UpdateActivity,
  SearchActivity,
  FetchActivity,
  DeleteActivity,
  CreateNewTimeSessionForActivity,
  UpdateTimeSession,
  GetTimeSessionForActivity,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import stopCircle from "../../assets/icons/stop-circle2.svg";
import Stop from "../../assets/icons/stop-circle.svg";
import "./Activity.css";
import CurrencyInput from "react-currency-input";
import { Tooltip } from "antd";
import moment from "moment";
import TaskEquipmentList from "../../components/Dailogs/TaskEquipmentList";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const emptyActivityRow = () => ({
  id: `equipment-${Date.now()}-${Math.random()}`,
  activityId: `temp-${Date.now()}-${Math.random()}`,
  equipmentid: "",
  equipmentname: "",
  activityName: "",
  estimatedUnit: "",
  estimatedTime: "",
  runTime: "",
  costRate: "",
  consumedTime: "0.00",
  canRun: true,
  assignees: [],
});

const Activity = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const userId = window.localStorage.getItem("userid");

  const [anchorEl, setAnchorEl] = useState(null);

  const [fetchTransUpdateTaskList, setFetchTransUpdateTaskList] = useState({});

  useEffect(() => {
    fetchScreenTranslations("Updated-Task").then((res) => {
      setFetchTransUpdateTaskList(res);
    });
  }, []);

  const t = (key) => fetchTransUpdateTaskList?.[key] || "";

  const addTaskResponse = useSelector((state) => state.user.addTaskResponse);

  const addTaskActivityRes = useSelector(
    (state) => state.user.addTaskActivityRes,
  );

  const searchActivityRes = useSelector(
    (state) => state.user.searchActivityRes,
  );

  const fetchActivityRes = useSelector((state) => state.user.fetchActivityRes);

  const deleteActivityRes = useSelector(
    (state) => state.user.deleteActivityRes,
  );

  const timerActivityRes = useSelector((state) => state.user.timerActivityRes);

  const UpdateTimeSessionResponse = useSelector(
    (state) => state.user.UpdateTimeSessionResponse,
  );

  const getTimerActivityRes = useSelector(
    (state) => state.user.getTimerActivityRes,
  );

  const [openActivityIndex, setOpenActivityIndex] = useState(null);
  const [activityData, setActivityData] = useState([emptyActivityRow()]);
  const activityDataRef = useRef(activityData);
  const [searchData, setSearchData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [addActivity, setAddActivity] = useState("");
  const [taskEquipmentPopupIndex, setTaskEquipmentPopupIndex] = useState(null);
  const [selectedTaskEquipments, setSelectedTaskEquipments] = useState([]);

  const { onEquipmentsChange } = props;
  const { onActivityDataChange } = props;
  useEffect(() => {
    onActivityDataChange?.(activityData);
  }, [activityData, onActivityDataChange]);

  useEffect(() => {
    onEquipmentsChange?.(
      activityData
        .filter((item) => item.equipmentid)
        .map(({ equipmentid, equipmentname }) => ({
          equipmentid,
          equipmentname,
        })),
    );
  }, [activityData, onEquipmentsChange]);

  useEffect(() => {
    activityDataRef.current = activityData;
  }, [activityData]);

  useEffect(() => {
    dispatch(SearchActivity({}));
  }, [dispatch]);

  useEffect(() => {
    dispatch(FetchActivity({ taskid: props?.taskId }));
  }, [
    dispatch,
    props?.taskId,
    addTaskActivityRes,
    deleteActivityRes,
    UpdateTimeSessionResponse,
  ]);

  const handleChange = (index, field, value) => {
    const list = [...activityData];
    list[index][field] = value;

    setActivityData(list);
  };

  const handleCostRateChange = (index, value) => {
    const list = activityData.map((item, itemIndex) =>
      itemIndex === index ? { ...item, costRate: value } : item,
    );

    setActivityData(list);
  };

  const handleAddActivity = (
    activities = activityData,
    taskId = props.taskId || addTaskResponse?.data?.taskid,
  ) => {
    const addActivities = activities.filter(
      (item) =>
        !item.taskActivityId && item.activityName?.trim() && item.equipmentid,
    );

    if (!taskId || addActivities.length === 0) return;

    const payload = {
      taskid: taskId,
      taskActivity: addActivities.map((item) => ({
        activityName: item.activityName,
        equipmentId: item.equipmentid,
      })),
    };
    dispatch(AddTaskActivity(payload));
  };

  useEffect(() => {
    const createdTaskId = addTaskResponse?.data?.taskid;
    if (props.modalFunction !== "add" || !createdTaskId) return;

    const pendingActivities = activityDataRef.current.filter(
      (item) => item.pendingAdd,
    );
    if (pendingActivities.length === 0) return;

    dispatch(
      AddTaskActivity({
        taskid: createdTaskId,
        taskActivity: pendingActivities.map((item) => ({
          activityName: item.activityName,
          equipmentId: item.equipmentid,
        })),
      }),
    );

    const pendingIds = new Set(
      pendingActivities.map((item) => item.activityId),
    );
    setActivityData((prev) =>
      prev.map((item) =>
        pendingIds.has(item.activityId) ? { ...item, pendingAdd: false } : item,
      ),
    );
  }, [addTaskResponse, dispatch, props.modalFunction]);

  const handleUpdateActivity = (activities = activityData) => {
    const updateActivities = activities.filter((item) => item.taskActivityId);

    if (updateActivities.length === 0) return;

    const payload = {
      taskActivity: updateActivities.map((item) => ({
        taskActivityId: item.taskActivityId,
        activityName: item.activityName,
        equipmentId: item.equipmentid,
      })),
    };

    dispatch(UpdateActivity(payload));
  };

  useEffect(() => {
    if (searchActivityRes?.status) {
      setSearchData(searchActivityRes.data);
    }
  }, [searchActivityRes]);

  useEffect(() => {
    dispatch(
      GetTimeSessionForActivity({
        projectId: props?.projectId,
        taskid: props?.taskId,
        userId: userId,
        currentDate: moment().format("DD/MM/YYYY"),
        currentTime: moment().format("HH:mm:ss"),
      }),
    );
  }, [
    dispatch,
    props?.projectId,
    props?.taskId,
    timerActivityRes,
    UpdateTimeSessionResponse,
    userId,
  ]);

  useEffect(() => {
    if (!props?.taskId || props.modalFunction === "add") {
      setActivityData([emptyActivityRow()]);
      return;
    }

    if (fetchActivityRes?.status && getTimerActivityRes?.data) {
      const updated = fetchActivityRes.data.map((activity) => {
        const timer = getTimerActivityRes.data.find(
          (x) => x.activityId === activity.activityId,
        );
        const currentActivity = activityDataRef.current.find(
          (item) =>
            item.activityId === activity.activityId ||
            (item.activityId?.toString().startsWith("temp-") &&
              item.activityName === activity.activityName),
        );

        return {
          ...activity,
          activityId: activity.activityId,
          equipmentid:
            activity.equipmentid ??
            activity.equipmentId ??
            currentActivity?.equipmentid ??
            "",
          equipmentname:
            activity.equipmentname ??
            activity.equipmentName ??
            activity.equipment?.equipmentname ??
            currentActivity?.equipmentname ??
            "",
          estimatedUnit:
            activity.timeUnit ??
            activity.estimatedUnit ??
            currentActivity?.estimatedUnit ??
            "Select",
          estimatedTime:
            activity.setupTime ??
            activity.estimatedTime ??
            currentActivity?.estimatedTime ??
            "",
          runTime: activity.runTime ?? currentActivity?.runTime ?? "",
          costRate: String(
            activity.timeUnitPrice ??
              activity.costRate ??
              currentActivity?.costRate ??
              "0",
          ).replace(",", "."),
          totalCost:
            activity.totalcost ??
            activity.totalCost ??
            currentActivity?.totalCost ??
            "",
          co2: activity.co2 ?? activity.cO2 ?? currentActivity?.co2 ?? "",
          // FetchActivity is the source of truth. Keeping the existing local
          // assignees first was hiding newly added assignees from the API.
          assignees: activity.assignees ?? currentActivity?.assignees ?? [],
          canRun: timer?.canRun ?? true,
          currentTimeSessions: timer?.currentTimeSessions ?? [],
          timeSessions: timer?.timeSessions ?? [],
          hasTrackedTime:
            currentActivity?.hasTrackedTime ??
            (timer?.currentTimeSessions?.length > 0 ||
              timer?.timeSessions?.length > 0),
          totalHoursTracked: timer?.totalHoursTracked ?? "0.0",
          projectTaskTrackingTimeid:
            timer?.currentTimeSessions?.[0]?.projectTaskTrackingTimeid ||
            timer?.timeSessions?.[timer.timeSessions.length - 1]
              ?.projectTaskTrackingTimeid,
        };
      });

      // timer 00:00 set krna start
      const timerState = {};
      updated.forEach((item) => {
        if (!item.canRun && item.currentTimeSessions?.length > 0) {
          const session = item.currentTimeSessions[0];

          const start = moment(
            `${session.trackerStartDate} ${session.trackerStartTime}`,
            "DD/MM/YYYY HH:mm:ss",
          );

          const diff = moment.duration(moment().diff(start));

          const minutes = Math.floor(diff.asMinutes());
          const seconds = diff.seconds();

          timerState[item.activityId] =
            `${minutes}.${String(seconds).padStart(2, "0")}`;
        }
      });
      setRunTimer(timerState);
      // timer 00:00 set krna end

      setActivityData([...updated, emptyActivityRow()]);
    }
  }, [
    fetchActivityRes,
    getTimerActivityRes,
    props.modalFunction,
    props?.taskId,
  ]);

  const timerRef = useRef(null);
  const [runTimer, setRunTimer] = useState({});
  useEffect(() => {
    timerRef.current = setInterval(() => {
      setRunTimer((prev) => {
        const updated = { ...prev };

        activityData.forEach((item) => {
          if (!item.canRun) {
            const value = updated[item.activityId] || "0.00";

            let [m = "0", s = "0"] = value.split(".");

            m = Number(m);
            s = Number(s) + 1;

            if (s === 60) {
              m++;
              s = 0;
            }

            updated[item.activityId] = `${m}.${String(s).padStart(2, "0")}`;
          }
        });

        return updated;
      });
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [activityData]);

  return (
    <div style={{ marginTop: "3rem", position: "relative" }}>
      <div
        id="actiTable"
        className="task-modal-dependencies-box-1 px-0 pb-"
        // style={{ color: "#333333", ...props.actiTable }}
        style={{
          color: "#333333",
          ...props.actiTable,
          height:
            location.pathname.includes("/my-task") &&
            (taskEquipmentPopupIndex !== null || openActivityIndex !== null)
              ? "80vh"
              : undefined,
        }}
      >
        <p className="mb-2" style={{ color: "#333333", paddingLeft: "32px" }}>
          {t("Production")}
        </p>
        <table className="table">
          <thead>
            <tr className="atitableHeading">
              <th
                className="activityTH fw-bold pt-4"
                style={{ minWidth: "22%", width: "18%", paddingLeft: "33px" }}
              >
                {t("Equipment")}
              </th>
              <th
                className="activityTH fw-bold"
                style={{ width: "22%", paddingLeft: "15px" }}
              >
                {/* Activity */}
                {t("Activity")}
              </th>
              <th className="activityTH" style={{ width: "8%" }}>
                {/* Time */}
                {t("Time")}
              </th>
              <th className="activityTH" style={{ width: "8%" }}>
                {/* Setup */}
                {t("Setup")}
              </th>
              <th className="activityTH" style={{ width: "8%" }}>
                {/* Run */}
                {t("Run")}
              </th>
              <th className="activityTH" style={{ width: "10%" }}>
                {/* Cost rate */}
                {t("Cost rate")}
              </th>
              <th className="activityTH" style={{ width: "15%" }}>
                {/* Consumed time */}
                {t("Consumed time")}
              </th>
              <th className="activityTH" style={{ width: "12%" }}>
                {/* Track time */}
                {t("Track time")}
              </th>
            </tr>
          </thead>

          <tbody className="tabLine">
            {activityData.map((item, index) => {
              const setupAndRunTime =
                Number(String(item.estimatedTime || "0").replace(",", ".")) +
                Number(String(item.runTime || "0").replace(",", "."));
              const consumedMinutes = Number(
                String(item.consumedTime ?? "0").split(".")[0],
              );
              const hasTrackedTime =
                item.hasTrackedTime ||
                !item.canRun ||
                Number(String(item.consumedTime || "0").replace(",", ".")) >
                  0 ||
                Number(
                  String(item.totalHoursTracked || "0").replace(",", "."),
                ) > 0 ||
                item.currentTimeSessions?.length > 0 ||
                item.timeSessions?.length > 0;

              return (
                <tr
                  key={
                    item.taskActivityId || item.activityId || item.id || index
                  }
                  style={{
                    verticalAlign: "middle",
                    // borderBottom: "0.5px dotted #A5A5A5",
                  }}
                >
                  <td
                    className="position-relative"
                    style={{ paddingLeft: "30px" }}
                  >
                    <div className="d-flex gap-1">
                      <input
                        title={item.equipmentname || ""}
                        readOnly
                        disabled={hasTrackedTime}
                        className="activityinput truncate pointer"
                        style={props.activityStyle}
                        placeholder={t("Type an equipment")}
                        value={item.equipmentname || ""}
                        onClick={(e) => {
                          if (hasTrackedTime) return;
                          setSelectedTaskEquipments(
                            item.equipmentid
                              ? [
                                  {
                                    equipmentid: item.equipmentid,
                                    equipmentname: item.equipmentname,
                                  },
                                ]
                              : [],
                          );
                          setTaskEquipmentPopupIndex(index);
                          setAnchorEl(e.currentTarget);
                        }}
                      />

                      {taskEquipmentPopupIndex === index && (
                        <SmartPopup
                          open={Boolean(anchorEl)}
                          anchorEl={anchorEl}
                          placement="auto"
                          onClose={() => {
                            // setAnchorEl(null);
                            // setTaskEquipmentPopupIndex(null);
                          }}
                          style={{ zIndex: 9999 }}
                        >
                          <TaskEquipmentList
                            setToggleEquipment={() =>
                              setTaskEquipmentPopupIndex(null)
                            }
                            selectedEquipments={selectedTaskEquipments}
                            setSelectedEquipments={setSelectedTaskEquipments}
                            singleSelect
                            onApply={(equipments) => {
                              const equipment = equipments[0];
                              if (!equipment) return;

                              const updatedRow = {
                                ...item,
                                equipmentid: equipment.equipmentid,
                                equipmentname: equipment.equipmentname,
                                estimatedUnit: equipment.timeUnit || "Select",
                                estimatedTime: equipment.setupTime || "",
                                runTime: equipment.runTime || "",
                                costRate: String(
                                  equipment.timeUnitPrice || "0",
                                ).replace(",", "."),
                                totalCost: equipment.totalcost || "",
                                co2: equipment.co2 || "",
                              };

                              setActivityData((prev) =>
                                prev.map((row, rowIndex) =>
                                  rowIndex === index ? updatedRow : row,
                                ),
                              );
                              if (updatedRow.taskActivityId) {
                                handleUpdateActivity([updatedRow]);
                              }
                              setSelectedTaskEquipments([]);
                              setTaskEquipmentPopupIndex(null);
                            }}
                            // style={{ left: "30px", top: "45px" }}
                            style={{ position: "unset" }}
                          />
                        </SmartPopup>
                      )}
                    </div>
                  </td>

                  {/* Activity */}
                  <td className="position-relative">
                    <div className="d-flex gap-3 align-items-center pointer">
                      <input
                        type="text"
                        placeholder={t("Type an activity")}
                        title={item.activityName || addActivity}
                        value={item.activityName || addActivity}
                        // disabled={hasTrackedTime}
                        disabled={
                          hasTrackedTime || index !== activityData.length - 1
                        }
                        className="acti_header_search py-1 border-0"
                        style={{ minWidth: "100px" }}
                        onChange={(e) => {
                          // setAddActivity(e.target.value);
                          handleChange(index, "activityName", e.target.value);
                        }}
                        onFocus={() => {
                          if (hasTrackedTime) return;
                          // setOpenActivityIndex(index); open popup
                        }}
                        onBlur={() => {
                          setTimeout(() => {
                            setOpenActivityIndex(null);
                          }, 500);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            if (!addActivity.trim()) return;

                            setSearchData((prev) => [
                              // ...prev,
                              {
                                activityName: addActivity,
                              },
                              ...prev,
                            ]);

                            const updatedActivityData = activityData.map(
                              (activity, activityIndex) =>
                                activityIndex === index
                                  ? {
                                      ...activity,
                                      activityId:
                                        activity.activityId ||
                                        `temp-${Date.now()}`,
                                      activityName: addActivity,
                                      canRun: true,
                                    }
                                  : activity,
                            );

                            setActivityData(updatedActivityData);
                            if (updatedActivityData[index].taskActivityId) {
                              handleUpdateActivity([
                                updatedActivityData[index],
                              ]);
                            }

                            setAddActivity("");
                            setOpenActivityIndex(null);
                          }
                        }}
                      />
                    </div>

                    {openActivityIndex === index && (
                      <div
                        className="acti_Select_Outer"
                        style={{ left: "0", top: "55px", minWidth: "220px" }}
                      >
                        <div
                          className="p-0"
                          style={{ overflow: "auto", height: "300px" }}
                        >
                          {searchData
                            ?.filter((item) =>
                              item.activityName
                                ?.toLowerCase()
                                .includes(addActivity.toLowerCase()),
                            )
                            ?.map((activityOption, activityOptionIndex) => {
                              return (
                                <div
                                  key={activityOptionIndex}
                                  className="acti_row ulterDrop"
                                  onMouseDown={(e) => {
                                    e.preventDefault();
                                    if (
                                      activityData?.some(
                                        (data, dataIndex) =>
                                          dataIndex !== index &&
                                          data.activityId ===
                                            activityOption.activityId,
                                      )
                                    )
                                      return; // disable duplicate activity.

                                    const updatedActivityData =
                                      activityData.map(
                                        (activity, activityIndex) =>
                                          activityIndex === index
                                            ? {
                                                ...activity,
                                                ...activityOption,
                                                equipmentid:
                                                  activity.equipmentid,
                                                equipmentname:
                                                  activity.equipmentname,
                                                estimatedUnit:
                                                  activity.estimatedUnit,
                                                estimatedTime:
                                                  activity.estimatedTime,
                                                runTime: activity.runTime,
                                                costRate: activity.costRate,
                                                totalCost: activity.totalCost,
                                                co2: activity.co2,
                                                activityId:
                                                  activity.activityId ||
                                                  `temp-${Date.now()}`,
                                                activityName:
                                                  activityOption.activityName,
                                                canRun: true,
                                              }
                                            : activity,
                                      );

                                    setActivityData(updatedActivityData);
                                    if (
                                      updatedActivityData[index].taskActivityId
                                    ) {
                                      handleUpdateActivity([
                                        updatedActivityData[index],
                                      ]);
                                    }
                                    setSearchValue("");
                                    setAddActivity("");
                                    setOpenActivityIndex(null);
                                  }}
                                >
                                  <p className="w-100 py-1 ps-3 mb-1">
                                    {activityOption.activityName}
                                  </p>
                                </div>
                              );
                            })}
                          {searchData.filter((item) =>
                            item.activityName
                              ?.toLowerCase()
                              .includes(searchValue),
                          ).length === 0 && (
                            <span className="noDataDisplay pt-5 ps-3">
                              {/* No data to display! */}
                              {t("No data to display!")}
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                  </td>

                  {/* Estimated Time */}
                  <td>
                    <p className="acti-form-control mb-0">
                      {/* {item.estimatedUnit || t("time")} */}
                      {item.equipmentid ? (
                        item.estimatedUnit &&
                        item.estimatedUnit !== "Select" ? (
                          item.estimatedUnit
                        ) : (
                          "-"
                        )
                      ) : (
                        <span className="opacity-50">{t("time")}</span>
                      )}
                    </p>
                  </td>

                  {/* setup */}
                  <td>
                    <input
                      type="number"
                      className="acti-form-control"
                      readOnly
                      placeholder="0"
                      value={item.estimatedTime}
                      onChange={(e) =>
                        handleChange(index, "estimatedTime", e.target.value)
                      }
                      style={{ width: "60px" }}
                    />
                  </td>

                  {/* Run */}
                  <td>
                    <input
                      type="number"
                      readOnly
                      className="acti-form-control"
                      placeholder="0"
                      value={item.runTime || ""}
                      onChange={(e) =>
                        handleChange(index, "runTime", e.target.value)
                      }
                      style={{ width: "60px" }}
                    />
                  </td>

                  {/* Cost Rate */}
                  <td>
                    <CurrencyInput
                      className="acti-form-control"
                      placeholder="0"
                      readOnly
                      value={Number(item.costRate)}
                      decimalSeparator=","
                      thousandSeparator="."
                      precision="2"
                      allowEmpty={true}
                      prefix="€ "
                      style={{
                        // border: fieldErrors?.[index]?.costprice
                        //   ? "1px solid red"
                        //   : "",
                        border: "none",
                        width: "100%",
                        minWidth: "70px",
                      }}
                      onChange={(event, value) => {
                        handleCostRateChange(index, value);
                      }}
                    />
                  </td>

                  {/* Consumed Time */}
                  <td>
                    <div className="d-flex gap-1">
                      <p
                        className="mb-0 acti-form-control text-end"
                        style={{
                          minWidth: "70px",
                          width: "44%",
                          background: "#dddddd",
                          color: "#477400",
                        }}
                      >
                        {String(item?.consumedTime || "0")
                          .split(".")[0]
                          .padStart(2, "0")}{" "}
                        M
                      </p>
                      <p
                        className="mb-0 acti-form-control text-end"
                        style={{
                          minWidth: "50px",
                          width: "32%",
                          background: "#dddddd",
                          color: "#707070",
                        }}
                      >
                        {setupAndRunTime > 0
                          ? `${Math.floor(
                              (consumedMinutes / setupAndRunTime) * 100,
                            )}%`
                          : "0%"}
                      </p>
                    </div>
                  </td>

                  {/* Track Time in table show */}
                  <td className="position-relative">
                    {index === activityData.length - 1 && (
                      <button
                        type="button"
                        className="border-0 production-add"
                        title="Add row"
                        onClick={() => {
                          if (!item.equipmentid || !item.activityName) return;
                          const createdTaskId = addTaskResponse?.data?.taskid;

                          if (props.modalFunction === "add") {
                            if (createdTaskId) {
                              handleAddActivity([item], createdTaskId);
                            }
                          } else {
                            handleAddActivity([item], props.taskId);
                            handleUpdateActivity([item]);
                          }

                          setActivityData((prev) => [
                            ...prev.map((row, rowIndex) =>
                              rowIndex === index &&
                              props.modalFunction === "add" &&
                              !createdTaskId
                                ? { ...row, pendingAdd: true }
                                : row,
                            ),
                            emptyActivityRow(),
                          ]);
                        }}
                      >
                        +
                      </button>
                    )}

                    {index !== activityData.length - 1 && (
                      <div className="d-flex gap-2 align-items-center">
                        <Tooltip
                          title={
                            !item?.equipmentid
                              ? "Please select an equipment first"
                              : item?.canRun
                                ? "Run Timer"
                                : "Stop Timer"
                          }
                        >
                          <img
                            src={item.canRun ? stopCircle : Stop}
                            alt=""
                            className="mt-1 ms-1 pointer"
                            style={{
                              width: "25px",
                              filter: "contrast(0)",
                              opacity: item?.equipmentid ? 1 : 0.5,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!item?.equipmentid) return;

                              if (item?.canRun) {
                                setTaskEquipmentPopupIndex(null);
                                setOpenActivityIndex(null);
                                setRunTimer((prev) => ({
                                  ...prev,
                                  [item.activityId]: "0.00",
                                }));

                                setActivityData((prev) =>
                                  prev.map((activity) =>
                                    activity.activityId === item.activityId
                                      ? {
                                          ...activity,
                                          canRun: false,
                                          hasTrackedTime: true,
                                        }
                                      : activity,
                                  ),
                                );

                                dispatch(
                                  CreateNewTimeSessionForActivity({
                                    projectId: props?.projectId,
                                    taskid: props?.taskId,
                                    trackerStartDate:
                                      moment().format("DD/MM/YYYY"),
                                    trackerStartTime:
                                      moment().format("HH:mm:ss"),
                                    type: "Activity",
                                    description: "string",
                                    isManual: 0,
                                    userid: userId,
                                    activityId: item.activityId,
                                    equipmentId: item.equipmentid,
                                  }),
                                );
                              }

                              // stop timer
                              if (!item.canRun) {
                                dispatch(
                                  UpdateTimeSession(
                                    item?.projectTaskTrackingTimeid,
                                    moment().format("DD/MM/YYYY"), // trackerEndDate
                                    moment().format("HH:mm:ss"), // trackerEndTime
                                  ),
                                );
                                // timer 00:00 set krna start
                                setRunTimer((prev) => ({
                                  ...prev,
                                  [item.activityId]: "0.00",
                                }));

                                setActivityData((prev) =>
                                  prev.map((x) =>
                                    x.activityId === item.activityId
                                      ? { ...x, canRun: true }
                                      : x,
                                  ),
                                );
                                // timer 00:00 set krna end
                              }
                            }}
                          />
                        </Tooltip>

                        <p
                          className="mb-0 ps-2"
                          style={{ minWidth: "48px", maxWidth: "50px" }}
                        >
                          {(
                            runTimer[item.activityId] ||
                            item.totalHoursTracked ||
                            "0.0"
                          )
                            .split(".")[0]
                            .padStart(2, "0")}
                          :
                          {(
                            (
                              runTimer[item.activityId] ||
                              item.totalHoursTracked ||
                              "0.0"
                            ).split(".")[1] || "00"
                          ).padStart(2, "0")}
                        </p>

                        {/* Delete */}
                        <img
                          src={DeleteIcon}
                          alt=""
                          title="Delete"
                          width={15}
                          className="activityDeleteBtn ms-2 pointer opacity-50"
                          onClick={() => {
                            dispatch(
                              DeleteActivity({
                                taskid: props?.taskId,
                                activityId: item?.activityId,
                              }),
                            );
                          }}
                        />
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Activity;
